// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M21 4h-3V2h-2v6h2V6h3v15H3V6h2V4H3a2 2 0 0 0-2 2v15c0 1.1.9 2 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM8 6h7V4H8V2H6v6h2V6Zm1 4H5v4h4v-4Zm5 0h-4v4h4v-4Zm1 4h4v-4h-4v4ZM5 19h4v-4H5v4Zm5 0h4v-4h-4v4Z"
      className={rtlFlipCss}
    />
  </BaseIcon>
)
